import React from 'react';
import "@components/Layout/global.css";

import { IdentityProvider } from '@context/identity-context';

export const wrapRootElement = ({ element }) => (
    <IdentityProvider>
        {element}
    </IdentityProvider>
);